export enum CalculationCostType {
    PER_DEVICE="Per Device",
    PER_NODE="Per Node"
}